import {useImageOverlayMapLayerProvider} from "base/component/geo";
import SquareIcon from "@mui/icons-material/Square";
import {createImageOverlayLayerLegend, useImageOverlayLayerObject} from "base/map";

const layersBounds = [
    [35.0, -14.000000001],
    [65.833333333, 26.666666667000005],
];

export function useFishingemploymentMapProvider(config) {
    const layer = useImageOverlayLayerObject({
        opacity: 0.5,
        imageUrl: "/images/Fishingemployment.png",
        imageBounds: layersBounds,
        legend: createImageOverlayLayerLegend({
            layerName: "Fishing Employment",
            layerType: "rst",
            legendItems: [
                {
                    label: "(FTEs)",
                    color: "white",
                    icon: null,
                },
                {
                    label: "<= 0,7300",
                    color: "#ffe3d8",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,7300 - 3,6500",
                    color: "#f2cfc2",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "3,6500 - 14,1700",
                    color: "#f1af93",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "14,1700 - 40,5400",
                    color: "#ee7649",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "40,5400 - 148,3900",
                    color: "#ca5134",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "> 148,3900",
                    color: "#952e16",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
            ],
        }),
    });
    const [provider] = useImageOverlayMapLayerProvider(layer, config);

    return provider;
}
